import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    categoryButtonsContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      '& #AddAnotherCheckBtn': {
        width: '216px',
      },
      '& #AddCommentBtn': {
        width: '167px',
      },
      '& > div > div': {
        alignItems: 'flex-end',
      },
    },
    content: {
      overflow: 'scroll',
      height: 'calc(100vh - 123px)',
      alignContent: 'flex-start',
    },
    categoryTitle: {
      maxWidth: '100%',
      paddingLeft: '3px',
    },
    locationDetails: {
      minWidth: '300px',
      paddingTop: '10px',
      paddingLeft: '10px',
    },
    card: {
      padding: '16px',
      '& h3': {
        paddingLeft: '5px',
        paddingBottom: '5px',
      },
    },
    commentsContainer: {
      padding: '15px 15px 15px 5px',
    },
    buttonGroupContainer: {
      marginTop: '8px',
    },
    toggleDisabledButSelected: {
      color: '#2AAB3F',
      backgroundColor: '#2AAB3F14',
    },
    dropdown: {
      width: '30%',
    },
  }),
);

export default useStyles;
